const normalizeAudioUrl = (audioUrl) => {
  if (!audioUrl || typeof audioUrl !== 'string') return null
  const trimmed = audioUrl.trim()
  if (!trimmed) return null

  if (
    trimmed.startsWith('http://') ||
    trimmed.startsWith('https://') ||
    trimmed.startsWith('blob:') ||
    trimmed.startsWith('data:')
  ) {
    return trimmed
  }
  if (trimmed.startsWith('/api/') || trimmed.startsWith('/')) {
    return trimmed
  }
  return trimmed
}

export const hasCantiqueAudio = (cantique) => {
  if (!cantique) return false
  return Boolean(normalizeAudioUrl(cantique.audioUrl))
}

export const resolveCantiqueAudioUrl = (audioUrl) => normalizeAudioUrl(audioUrl)

export const getCantiqueAudioUrl = (cantique) => {
  if (!cantique) return null
  return resolveCantiqueAudioUrl(cantique.audioUrl)
}
